import Vue from 'vue';
import VueI18n from '@/libs/i18n/index';

// const timer = 3000;

class MessageDialogHelper {

  displayCreateSuccessMessage() {
    this.displaySuccessMessage('criado');
  }
  displayUpdateSuccessMessage() {
    this.displaySuccessMessage('atualizado');
  }
  displayDeleteSuccessMessage() {
    this.displaySuccessMessage('deletado');
  }

  displaySuccessMessage(type) {
    Vue.prototype.$swal({
      text: `Dados ${type} com sucesso!`,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: true,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }

  displaySuccessMess(text) {
    Vue.prototype.$swal({
      text: text,
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: true,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }

  displayDeleteDataMessage(callback) {
    Vue.prototype.$swal({
      title: VueI18n.t('DIALOG_MESSAGES.DeleteTitle'),
      text: VueI18n.t('DIALOG_MESSAGES.DeleteConfirmText'),
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: true,
      confirmButtonText: VueI18n.t('DIALOG_MESSAGES.ConfirmYes'),
      cancelButtonText: VueI18n.t('BUTTONS.Cancel'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        this.displayDeleteSuccessMessage();
        callback();
      }
    });
  }

  displayWithInputTextSubmit(title, callback) {
    Vue.prototype.$swal({
      title: title,
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: VueI18n.t('BUTTONS.Save'),
      cancelButtonText: VueI18n.t('BUTTONS.Cancel'),
      showLoaderOnConfirm: true,
      preConfirm: (inputText) => {console.log(`dialog with input text val: ${inputText}`)},
    }).then((result) => {
      if (result.isConfirmed) {
        callback(result.value);
      }
    })
    
    // Vue.prototype.$swal({
    //   title: 'Deletar',
    //   text: 'Você tem certeza em deletar?',
    //   icon: 'warning',
    //   showCancelButton: true,
    //   allowOutsideClick: true,
    //   confirmButtonText: 'Sim, tenho certeza!',
    //   cancelButtonText: 'Cancelar',
    //   customClass: {
    //     confirmButton: 'btn btn-primary',
    //     cancelButton: 'btn btn-outline-danger ml-1',
    //   },
    //   buttonsStyling: false,
    // }).then(result => {
    //   if (result.value) {
    //     this.displayDeleteSuccessMessage();
    //     callback();
    //   }
    // });
  }

  displayConfirmMessage(title, text, callback) {
    Vue.prototype.$swal({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: true,
      confirmButtonText: VueI18n.t('DIALOG_MESSAGES.ConfirmYes'),
      cancelButtonText: VueI18n.t('BUTTONS.Cancel'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      if (result.value) {
        callback();
      }
    });
  }

  displayConfirmMessageWithResponseVal(title, text, callback) {
    Vue.prototype.$swal({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick: true,
      confirmButtonText: VueI18n.t('DIALOG_MESSAGES.ConfirmYes'),
      cancelButtonText: VueI18n.t('BUTTONS.Cancel'),
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false,
    }).then(result => {
      callback(result.value);
    });
  }

  displayDefaultMessage(title, text) {
    Vue.prototype.$swal({
      title: title,
      text: text,
      showCancelButton: false,
      allowOutsideClick: true,
      confirmButtonText: VueI18n.t('DIALOG_MESSAGES.ConfirmYes'),
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }

  // displayPlatformTour(callback) {
  //   Vue.prototype.$vs.dialog({
  //     type: "confirm",
  //     color: "primary",
  //     title: VueI18n.t('DIALOG_MESSAGES').Title,
  //     text: VueI18n.t('DIALOG_MESSAGES').PlatformTourText,
  //     accept: () => {
  //       callback('accept');
  //     },
  //     cancel: () => {
  //       callback('cancel');
  //     },
  //     acceptText: VueI18n.t('DIALOG_MESSAGES').StartText,
  //     cancelText: VueI18n.t('DIALOG_MESSAGES').NotDisplatText,
  //   });
  // }

}

export default new MessageDialogHelper();
